import * as React from "react";

function LockFill(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "LockFill-LockFill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LockFill-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "LockFill-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0000226,4 C30.8021102,4 36.3157921,9.54285714 36.3157921,16.3809375 L36.3157921,22.0952232 L36.3157919,22.0952232 C39.4550912,22.0952231 42,24.6535938 42,27.8095089 C42,27.8095089 42,27.8095089 42,27.8095089 L42,38.2857143 L42,38.2857143 C42,41.441625 39.4550912,44 36.3157919,44 L11.6842084,44 L11.6842081,44 C8.5449088,44 6,41.441625 6,38.2857143 C6,38.2857143 6,38.2857143 6,38.2857143 L6,27.8095089 L6,27.8095098 C6,24.6535991 8.54490436,22.0952241 11.6842081,22.0952241 L11.6842081,16.3809384 C11.6842081,9.54285801 17.1978901,4 23.9999777,4 L24.0000226,4 Z M25.5158099,29.7142857 L23.4316018,29.7142857 L23.4316017,29.7142857 C23.222315,29.7142857 23.0526547,29.8848438 23.0526547,30.0952379 L23.0526547,35.047604 C23.0526547,35.2571277 23.2231809,35.4285562 23.4316017,35.4285562 L25.5158099,35.4285562 L25.5158099,35.4285562 C25.7250967,35.4285562 25.894757,35.2579982 25.894757,35.047604 C25.894757,35.047604 25.894757,35.047604 25.894757,35.047604 L25.894757,30.0952379 L25.894757,30.0952379 C25.894757,29.8848437 25.7250967,29.7142857 25.5158099,29.7142857 C25.5158099,29.7142857 25.5158099,29.7142857 25.5158099,29.7142857 L25.5158099,29.7142857 Z M24.0000226,6.85714272 C18.8558142,6.85714272 14.6703275,10.9780938 14.5301318,16.1142857 L14.5263423,16.3809522 L14.5263423,22.0952379 L33.4737176,22.0952379 L33.4737176,16.3809522 C33.4737176,11.2095237 29.3744577,7.00188973 24.2653004,6.86095223 L24.0000375,6.85714272 L24.0000226,6.85714272 Z",
    id: "LockFill-\u5F62\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default LockFill;